import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { chargerFavoris, enregistrerFavoris, type Favoris } from "../nav/favoris";
import { useAuth } from "./useAuth";

export const FAVORIS_QUERY_KEY = ["favoris"] as const;

/** Favoris du compte, partagés par le menu « Mon espace » et le tableau de bord. */
export function useFavoris(enabled = true) {
  const { authState } = useAuth();

  return useQuery<Favoris | null, Error>({
    queryKey: FAVORIS_QUERY_KEY,
    queryFn: () => chargerFavoris(),
    enabled: enabled && authState.type === "authenticated",
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}

export function useEnregistrerFavoris() {
  const queryClient = useQueryClient();

  return useMutation<Favoris, Error, string[]>({
    mutationFn: (paths) => enregistrerFavoris(paths),
    onSuccess: (data) => queryClient.setQueryData(FAVORIS_QUERY_KEY, data),
  });
}
